var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.75C2.86193 2.75 2.75 2.63807 2.75 2.5C2.75 2.36193 2.86193 2.25 3 2.25H6C6.13807 2.25 6.25 2.36193 6.25 2.5V5.5C6.25 5.63807 6.13807 5.75 6 5.75C5.86193 5.75 5.75 5.63807 5.75 5.5V3.10355L2.17678 6.67678C2.07915 6.77441 1.92085 6.77441 1.82322 6.67678C1.72559 6.57915 1.72559 6.42085 1.82322 6.32322L5.39645 2.75H3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.e3ad837f96b89e7f9e5629ca6cbad94b.svg";
export { ForwardRef as ReactComponent };